import React from 'react';

function Socials() {
  return (
    <section id="socials">
      <h2>Socials</h2>
      <div className="social-icons">
        {/* <a href="https://facebook.com/profile.php?id=100087656160762" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a> */}
        <a href="https://instagram.com/TimeWasterNL" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
        {/* <a href="https://soundcloud.com/TimeWasterNL" target="_blank" rel="noopener noreferrer"><i className="fab fa-soundcloud"></i></a> */}
        <a href="https://open.spotify.com/artist/4rTWBToWooAmfwG8VFdqJn" target="_blank" rel="noopener noreferrer"><i className="fab fa-spotify"></i></a>
        <a href="https://t.me/TimeWasterNL" target="_blank" rel="noopener noreferrer"><i className="fab fa-telegram"></i></a>
        {/* <a href="https://tiktok.com/TimeWasterNL" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a> */}
        {/* <a href="https://twitch.com/TimeWasterNL" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitch"></i></a> */}
        <a href="https://untappd.com/user/TimeWasterNL" target="_blank" rel="noopener noreferrer"><i className="fab fa-untappd"></i></a>
        <a href="https://youtube.com/TimeWasterNL" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
      </div>
    </section>
  );
}

export default Socials;
